import { PayloadAction } from '@reduxjs/toolkit';
import { UserId } from 'features/users/types';
import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* allowEditWhiteboardSaga(action: PayloadAction<UserId>) {
  yield call(SignalingSocket.send, {
    event: 'allowEditWhiteboard',
    data: {
      id: action.payload,
    },
  });
}
